import { render, staticRenderFns } from "./campaignExpressAdd.vue?vue&type=template&id=b46f60c6&scoped=true&"
import script from "./campaignExpressAdd.vue?vue&type=script&lang=js&"
export * from "./campaignExpressAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46f60c6",
  null
  
)

export default component.exports